import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { ReactNode } from "react";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";


interface AuthProviderProps {
    children? : ReactNode
}

export const AuthProvider = ({ children } : AuthProviderProps) => {
    const msalInstance = new PublicClientApplication(msalConfig);

   

    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      
       msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
       //todo ==> comment this out later 
      // console.log('account on page load', msalInstance.getAllAccounts()[0]) ;
    }else{
       // console.log('no account info')
    }

    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
        const authenticationResult = event.payload as AuthenticationResult;
        const account = authenticationResult?.account;
        if (event.eventType === EventType.LOGIN_SUCCESS && account) {
            msalInstance.setActiveAccount(account);
        }
       // console.log('account on sign in event', account) ;
      
    });
    
    console.log('msalInstance all account counts', msalInstance.getAllAccounts().length);
   
    return (
        <MsalProvider instance={msalInstance}>
           <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}> {/* this will check user login. if loged in, it load children page, other wise it will redirect to ms login */}
                  {children}
            </MsalAuthenticationTemplate> 
        </MsalProvider>
    );
}

/* wrapping around whole frontend site with msal login */

/*

    
*/